export const TABLE_COLUMNS_NAME = [
  {
    label: 'Ident',
    key: 'ident',
    flex: 1,
    minWidth: 200,
    maxWidth: 300,
  },
  {
    label: 'Etiqueta',
    key: 'label',
    minWidth: 300,
    flex: 1,
  },
  {
    label: 'Mantenimientos',
    key: 'maintenances',
    minWidth: 150,
    maxWidth: 150,
    centered: true,
  },
  {
    label: 'Total Manttos',
    key: 'maintenanceCosts',
    minWidth: 150,
    maxWidth: 150,
    centered: true,
  },
  {
    label: 'Reparaciones',
    key: 'reparations',
    minWidth: 150,
    maxWidth: 150,
    centered: true,
  },
  {
    label: 'Total Reparaciones',
    key: 'reparation_costs',
    minWidth: 150,
    maxWidth: 150,
    centered: true,
  },
  {
    label: 'Cargas',
    key: 'refuels',
    minWidth: 150,
    maxWidth: 150,
    centered: true,
  },
  {
    label: 'Total Cargas',
    key: 'refuel',
    minWidth: 150,
    maxWidth: 150,
    centered: true,
  },
];

export const EXTENDED_TABLE_COLUMNS_NAME = [
  {
    label: 'Ident',
    key: 'ident',
    flex: 1,
    minWidth: 200,
    maxWidth: 300,
  },
  {
    label: 'Etiqueta',
    key: 'label',
    minWidth: 300,
    flex: 1,
  },
  {
    label: 'Mantenimientos',
    key: 'maintenances',
    minWidth: 150,
    maxWidth: 150,
    centered: true,
  },
  {
    label: 'Total Manttos',
    key: 'maintenanceCosts',
    minWidth: 150,
    maxWidth: 150,
    centered: true,
  },
  {
    label: 'Reparaciones',
    key: 'reparations',
    minWidth: 150,
    maxWidth: 150,
    centered: true,
  },
  {
    label: 'Total Reparaciones',
    key: 'reparation_costs',
    minWidth: 150,
    maxWidth: 150,
    centered: true,
  },
  {
    label: 'Cargas',
    key: 'refuels',
    minWidth: 150,
    maxWidth: 150,
    centered: true,
  },
  {
    label: 'Total Cargas',
    key: 'refuel',
    minWidth: 150,
    maxWidth: 150,
    centered: true,
  },
];

export const TABLE_MIN_WIDTH = TABLE_COLUMNS_NAME.reduce((prev, current) => prev + (current.minWidth ?? 0), 0);
